import { oneLineTrim } from 'common-tags';
import {
    includeParam,
    filterParam,
    limitAllParam as pageSizeAllParam,
} from 'app/react/state/middleware/api'

export const fetchAll = (
    eventId,
    bookingId,
    filters = {},
    includes = []
) => oneLineTrim`
    events/${eventId}/bookings/${bookingId}/attendees?
    ${pageSizeAllParam}&
    ${filterParam(filters)}&
    ${includeParam(includes)}&
`;
